import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import CTAButton from "@/components/7fcc/CTAButton";
import { HOME } from "@/data/homeContent";

export default function BuiltForSection() {
  const b = HOME.builtFor;
  return (
    <section id="proof" className="bg-ink-950 px-6 py-16 md:py-24" data-testid="home-built-for">
      <div className="mx-auto max-w-5xl">
        <SectionHeader center eyebrow={b.eyebrow} title={b.headline} support={b.support} testId="home-builtfor-heading" />
        <div className="mt-12 grid gap-5 md:mt-16 md:grid-cols-3">
          {b.quotes.map((quote, i) => (
            <Reveal key={quote} delay={(i % 3) * 0.06} className="h-full">
              <div className="flex h-full flex-col rounded-lg border border-line bg-ink-900/60 p-6" data-testid={`home-quote-${i + 1}`}>
                <span aria-hidden="true" className="font-display text-3xl leading-none text-brand">
                  “
                </span>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-fg-muted md:text-base">{quote}</p>
              </div>
            </Reveal>
          ))}
          {/* CTA card — the 6th grid card, as on the live page */}
          <Reveal delay={0.2} className="h-full">
            <div
              className="flex h-full flex-col justify-center rounded-lg border border-brand/40 bg-brand/10 p-6"
              data-testid="home-builtfor-cta"
            >
              <h3 className="font-display text-xl font-semibold text-fg md:text-2xl">{b.ctaTitle}</h3>
              <p className="mt-3 text-sm leading-relaxed text-fg-muted md:text-base">{b.ctaBody}</p>
              <div className="mt-6">
                <CTAButton label={b.cta.label} targetId={b.cta.anchor} testId="home-builtfor-cta-btn" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}